// Paddle Billing — client-side checkout loader.
// Docs: https://developer.paddle.com/build/checkout/build-overlay-checkout

const PADDLE_CLIENT_TOKEN = process.env.REACT_APP_PADDLE_CLIENT_TOKEN || "";
const PADDLE_ENV = (process.env.REACT_APP_PADDLE_ENV || "sandbox").trim().toLowerCase();

let paddlePromise = null;

/**
 * Loads Paddle.js (once) and returns the global `Paddle` object,
 * initialized with the client-side token and environment.
 * Resolves to null if no client token is configured.
 */
export function loadPaddle() {
  if (!PADDLE_CLIENT_TOKEN) return Promise.resolve(null);
  if (paddlePromise) return paddlePromise;

  paddlePromise = new Promise((resolve, reject) => {
    if (window.Paddle) {
      window.Paddle.Environment.set(PADDLE_ENV);
      window.Paddle.Initialize({ token: PADDLE_CLIENT_TOKEN });
      resolve(window.Paddle);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;
    script.onload = () => {
      if (!window.Paddle) { reject(new Error("Paddle.js failed to load")); return; }
      window.Paddle.Environment.set(PADDLE_ENV);
      window.Paddle.Initialize({ token: PADDLE_CLIENT_TOKEN });
      resolve(window.Paddle);
    };
    script.onerror = () => reject(new Error("Paddle.js failed to load"));
    document.head.appendChild(script);
  });

  return paddlePromise;
}
